import React from 'react';
import { eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';
import { DateField } from 'ui-toolkit';
import { IFieldProps } from './IFieldProps';

export const GoodThruDate: React.FC<IFieldProps> = ({ baseName, readOnly }) => (
  <DateField
    name={`${baseName}.stringFeePropertyValues.${eFeePropertyNames.GoodThruDate}`}
    label={'Good Through'}
    placeholder={'mm/dd/yyyy'}
    data-test-id={'fee-detail-good-thru-date'}
    readOnly={readOnly}
    attachPortalInsideContainter
  />
);
